import { gql } from '@apollo/client';
import { FULL_FRAGMENT } from './fragments';

export const CREATE_ESTIMATE = gql`
  mutation CreateEstimate($data: CreateEstimateInput) {
    createEstimate(data: $data) {
      ... on CreateUpdateEstimate {
        message
        version
        estimate {
          id
          job_id
          account_id
          chat_id
          crew_id
          checklist_id
          client_account_id
          property_id
          isArchived
          name
          status
          property {
            id
            name
            address1
            address2
            city
            state
            zip
            country
          }
          clientApprovedSignatureImageUrl
          clientApprovedSignatureImageBase64
          clientApprovedSignatureTimestamp
          createdAt
          updatedAt
        }
      }
      ... on Error {
        errorCode
        message
      }
    }
  }
`;

export const UPDATE_ESTIMATE = gql`
  mutation updateEstimate($data: UpdateEstimateInput!) {
    updateEstimate(data: $data) {
      ... on CreateUpdateEstimate {
        message
        version
        estimate {
          ...EstimateFullFragment
        }
      }
      ... on Error {
        errorCode
        message
      }
    }
  }
  ${FULL_FRAGMENT}
`;

export const MARK_ESTIMATE_AS_VIEWED = gql`
  mutation markEstimateAsViewed($data: MarkEstimateAsViewedInput!) {
    markEstimateAsViewed(data: $data) {
      ... on MarkEstimateAsViewed {
        message
        version
        estimate_id
        viewed
      }
      ... on Error {
        errorCode
        message
      }
    }
  }
`;
